var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiManagedServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#2E539A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1v3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20v3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9h3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14h3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9h3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14h3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiManagedServices);
export default __webpack_public_path__ + "static/media/ai-managed-services.36bd5ac6e773c87248aa6f1cbe394300.svg";
export { ForwardRef as ReactComponent };